<template>
  <div>
    <a-button @click="showModal" class="change-password-btn">{{ $t('change.password') }}</a-button>
    <change-password-modal :visible="visible" @cancel="handleCancel" />
  </div>
</template>

<script>
import ChangePasswordModal from './ChangePasswordModal.vue';

export default {
  components: {
    ChangePasswordModal,
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    showModal() {
      this.visible = true;
    },
    handleCancel() {
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/colors';
@import '~@/assets/styles/breakpoints';

.change-password-btn {
  border: none;
  background-color: $light-blue;
  color: $blue;
  margin-right: 20px;
}

@media (max-width: $header-breakpoint) {
  .change-password-btn {
    width: 100%;
    margin: 0;
  }
}
</style>
